import React, { useState } from 'react';
import { CheckIcon, LinkIcon } from '../../icons';
import IconButton from '../IconButton';
import Tooltip from '@mui/material/Tooltip';
/**
 * Pigment [Copy Link Button](https://pigment.customink.com/?path=/docs/components-copy-link-button)
 */
var CopyLinkButton = function (_a) {
    var linkText = _a.linkText, _b = _a.resetTime, resetTime = _b === void 0 ? 5000 : _b, _c = _a.tooltipPlacement, tooltipPlacement = _c === void 0 ? 'top' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.color, color = _f === void 0 ? 'primary' : _f;
    var _g = useState(false), copied = _g[0], setCopied = _g[1];
    var icon = copied ? (React.createElement(CheckIcon, { fontSize: "inherit" })) : (React.createElement(LinkIcon, { fontSize: "inherit" }));
    return (React.createElement(Tooltip, { arrow: !copied, className: "infoTooltip", title: copied ? 'Link copied!' : 'Copy Link', placement: tooltipPlacement },
        React.createElement(IconButton, { disabled: disabled, color: color, size: size, onClick: function () {
                setCopied(true);
                setTimeout(function () {
                    setCopied(false);
                }, resetTime);
                navigator.clipboard.writeText(linkText);
            } }, icon)));
};
export default CopyLinkButton;
//# sourceMappingURL=CopyLinkButton.js.map